angular.module("vgresiduos").controller("ResidueMarketSupplierListGenerationCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/back-office/quadro-de-demanda`);
		};
	}
]);
